export default __webpack_public_path__ + "static/media/cancel-unstaking.588fab69.png";